import { useSelector } from "react-redux";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";
import {
  INTERCEPTOR_TRIGGERS,
  INTERCEPTOR_TRIGGER_IDS,
} from "../../../../utils/interceptorTriggers";
import {
  buildInterceptorExtraData,
  filterInterceptorField,
} from "../interceptor/shared";

const FORM_CODE = "interceptorPageDepth4";
const TRIGGER_INFO =
  INTERCEPTOR_TRIGGERS[INTERCEPTOR_TRIGGER_IDS.pageDepth4].info;

export default function InterceptorPageDepth4() {
  const { cityName } = useSelector((state) => state.location);
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.triggerFivePageOpen}
      goalSent={GOALS.triggerFivePageSent}
      filterField={filterInterceptorField}
      extraData={buildInterceptorExtraData({ info: TRIGGER_INFO, cityName })}
    />
  );
}
